import { Link } from 'react-router-dom'
import type { MarketAsset } from '../types'
import { resolveAssetImage, short, sol } from '../utils'

export function normalizeMarketAsset(asset: any): MarketAsset {
  return {
    ...asset,
    asset_id: asset?.asset_id || asset?.tokenMint || '',
    image_url: resolveAssetImage(asset),
    price_lamports: asset?.price_lamports || asset?.listing_price_lamports || asset?.priceLamports || 0,
  }
}

export function MarketIndexCard({ asset, verified = false }: { asset: MarketAsset; verified?: boolean }) {
  const id = String((asset as any)?.asset_id || (asset as any)?.tokenMint || '')
  const name = String((asset as any)?.name || short(id) || 'OnlyRose NFT')
  const image = resolveAssetImage(asset)
  const collection = String((asset as any)?.collection_name || (asset as any)?.collection?.name || 'OnlyRose')
  const price = Number((asset as any)?.price_lamports || (asset as any)?.listing_price_lamports || (asset as any)?.priceLamports || 0)

  return <Link className="market-index-card" to={`/nft/${encodeURIComponent(id)}`}>
    <div className="market-index-media">
      {image
        ? <img src={image} alt={name} loading="lazy" decoding="async" referrerPolicy="no-referrer"/>
        : <span>{name.slice(0, 1)}</span>}
      <span className={`market-index-state ${verified ? 'verified' : 'indexed'}`}>
        {verified ? 'Provider verified' : asset?.listed ? 'Indexed listing' : 'Indexed NFT'}
      </span>
    </div>
    <div className="market-index-body">
      <small>{collection}</small>
      <h3>{name}</h3>
      {price > 0 && <b>{sol(price)}</b>}
      <p>{verified
        ? 'Open NFT details for current marketplace actions.'
        : asset?.listed
          ? 'Open NFT details to revalidate current listing state.'
          : 'Open permanent NFT details.'}</p>
    </div>
  </Link>
}
